import { useTranslation } from 'react-i18next';
import { IconFileOff } from '@tabler/icons-react';
import { ICON_SIZE_EMPTY_STATE } from '@/constants';
import { EmptyState } from '@/components/common/EmptyState';

export function DownloadOnlyViewer() {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t('filePreview.noPreview')}
      description={t('filePreview.noPreviewDescription')}
      icon={<IconFileOff size={ICON_SIZE_EMPTY_STATE} />}
      size="md"
    />
  );
}
